import { _ as _defineProperty } from '../_chunks/dep-27452b12.js';
import { forwardRef, createElement } from 'react';
import { IconBase } from '../icon.js';
import '../style/css.js';
import '../util/use-size-props.js';
import '../util/use-common-classname.js';
import '../util/use-config.js';
import '../util/config-context.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var element = {
  "tag": "svg",
  "attrs": {
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "fill": "none",
    "viewBox": "0 0 26 27",
    "width": "1em",
    "height": "1em"
  },
  "children": [{
    "tag": "path",
    "attrs": {
      "fill": "url(#pattern0)",
      "d": "M4 0h22v27H4z"
    }
  }, {
    "tag": "defs",
    "attrs": {},
    "children": [{
      "tag": "pattern",
      "attrs": {
        "id": "pattern0",
        "width": 1,
        "height": 1,
        "patternContentUnits": "objectBoundingBox"
      },
      "children": [{
        "tag": "use",
        "attrs": {
          "transform": "scale(.04545 .03704)",
          "xlink:href": "#image0_1_3731"
        }
      }]
    }, {
      "tag": "image",
      "attrs": {
        "id": "image0_1_3731",
        "width": 22,
        "height": 27,
        "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAbCAYAAAB4Kn/lAAAAAXNSR0IArs4c6QAAAc5JREFUSA2llWlOw0AMhZmWTcBxKoo4BDfgjJyCH6AeB8RWGt5n7GiSTJpJa8myM2M/v/EsSU3TnPQlpbRhTHOr/lztd+oDAxpj8sG5zcA0VWCSBYR7Gs4ee+Fzv7JbitWA1wBfOfCP7Cfg0mH/PCjMHOAAhfmk1AA/OcqD7FJqjZ9Cnty82CvfyMBjQ2n1aEtqGAcYSOaryCuO7FqGwUGRBQGHiBd5Ue6ZdKkiC2nbJj42oXMLOPiz8jiSrB5sAzfGBKAUyME90YZyP49x/1r2Ugp7A+/02ME9dtwUinDWo630fLtQ0MrZjyNNz5wrhHbA2loSVdZHgoMDIGpnPYD1/S+FZcbUPsuGdTSA6cv9kaw7hXNgHpdZ4kQeS0kGrOXb7VHA3YGsI7+1wdjupIB3peoVYwCSy6p5/ZoWWB8IAVWse20gz34EbrvA3pK5rHO2MCa/6dw8DSAEci8xNZKzNWAIDt5jkARKi7j3vAE3Um4UB78ktIC/y5v0Xfoj3F2JseaMdWwG/zpAx1oEMDFtG+TbFcR2xJaSEkAkfElZ7j7G3x67I1d+GZgJCQGw+JCS2D9BGjKBQJwIA2V0rBXMEUQCifEOyB0IcblawB8b/ceCMFkocQAAAABJRU5ErkJggg=="
      }
    }]
  }]
};
var ClickIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(IconBase, _objectSpread(_objectSpread({}, props), {}, {
    id: "click",
    ref: ref,
    icon: element
  }));
});
ClickIcon.displayName = "ClickIcon";

export { ClickIcon as default };
//# sourceMappingURL=click.js.map
